module.exports = "/images/checkbox-base-gray.svg?57068bc63fc0c5cfc7d023d1bd397012";